export enum FontSize {
  DisplaySmall,
  HeadlineLarge,
  HeadlineMedium,
  HeadlineSmall,
  TitleLarge,
  TitleMedium,
  TitleSmall,
  LabelLarge,
  LabelMedium,
  LabelSmall,
  BodyLarge,
  BodyMedium,
  BodySmall,
}

// Please keep in sync with fonts.less
export const FONT_RAW_SIZES = {
  [FontSize.DisplaySmall]: {
    fontSize: 36,
    lineHeight: 44,
  },
  [FontSize.HeadlineLarge]: {
    fontSize: 32,
    lineHeight: 40,
  },
  [FontSize.HeadlineMedium]: {
    fontSize: 28,
    lineHeight: 36,
  },
  [FontSize.HeadlineSmall]: {
    fontSize: 24,
    lineHeight: 32,
  },
  [FontSize.TitleLarge]: {
    fontSize: 22,
    lineHeight: 28,
  },
  [FontSize.TitleMedium]: {
    fontSize: 16,
    lineHeight: 24,
    letterSpacing: "0.15px",
  },
  [FontSize.TitleSmall]: {
    fontSize: 14,
    lineHeight: 20,
    letterSpacing: "0.1px",
  },
  [FontSize.LabelLarge]: {
    fontSize: 14,
    lineHeight: 20,
    letterSpacing: "0.1px",
  },
  [FontSize.LabelMedium]: {
    fontSize: 12,
    lineHeight: 16,
    letterSpacing: "0.5px",
  },
  [FontSize.LabelSmall]: {
    fontSize: 11,
    lineHeight: 16,
    letterSpacing: "0.5px",
  },
  [FontSize.BodyLarge]: {
    fontSize: 16,
    lineHeight: 24,
    letterSpacing: "0.5px",
  },
  [FontSize.BodyMedium]: {
    fontSize: 14,
    lineHeight: 20,
    letterSpacing: "0.25px",
  },
  [FontSize.BodySmall]: {
    fontSize: 12,
    lineHeight: 16,
    letterSpacing: "0.4px",
  },
};

export function getFontStyle(size: FontSize): { fontSize: string; lineHeight: string } {
  return {
    ...FONT_RAW_SIZES[size],
    fontSize: `${FONT_RAW_SIZES[size].fontSize}px`,
    lineHeight: `${FONT_RAW_SIZES[size].lineHeight}px`,
  };
}

export const FONT_FAMILY = '"Noto Sans", Arial, sans-serif';
